import styled from 'styled-components';
import { InputText } from '../../../components';

export const Container = styled.div`
  width: 100%;
`;

export const Title = styled.div`
  width: 100%;
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.editorModalTextColor};
`;

export const Label = styled.span`
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 10px;
  display: block;
`;

export const StaticText = styled.span`
  font-size: 1.2em;
  margin-bottom: 10px;
  font-style: oblique;
  display: block;
  padding: 0px 5px;
`;

export const NewTitle = styled(Title)`
  margin-right: 10px;
`;

export const NewDate = styled(Title)`
`;

export const InputGroup = styled(InputText)`
`;

export const CustomErrorMessage = styled.span`
  margin-top: 4px;
  display: block;
  color: ${(props) => props.theme.colors.statusError};
  font-family: "Open Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const GroupInputs = styled.div`
  display:flex;
  gap: 10px;
  padding-bottom: 20px;
  @media (max-width: 586px) {
    display: block;
  }
`;
export const UsersTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead {

    tr {
      font-size: 1.4rem;
      color: ${(props) => props.theme.colors.editorModalTextColor};
      text-transform: uppercase;
      text-align: left;

      th {
        padding: 16px 10px;
      }
    }
  }

  tbody {
    tr {
      font-size: 1.2rem;

      td {
        padding: 0px 10px;
        color: ${(props) => props.theme.card.listItemsTextColor};
        font-size: 1.2rem;
        font-weight: 300;
      }

      .titulo {
        width: 600px;
      }

      .status {
        text-transform: uppercase;
        cursor: pointer;

        &.active {
          color: #11ada0;
        }

        &.inactive {
          color: #F08282;
        }

        &.active::before,
        &.inactive::before {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          display: inline-block;
          content: '';
          margin-right: 10px;
        }

        &.active::before {
          background-color: #11ada0;
        }

        &.active {
          color: #11ada0;
        }

        &.inactive {
          color: #f08282;
        }

        &.inactive::before {
          background-color: #f08282;
        }

        .popup-selector{
          display: inline-block;
        }
      }
    }
  }
`;

export const TableHead = styled.thead`
`;

export const TableBody = styled.tbody`
`;

export const DateContainer = styled.div`
  width: 50%;
  margin-right: 4px;
  @media (max-width: 586px) {
    width: 100%;
  }
`;
export const InputDateContainer = styled.div`
  margin-bottom: 10px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;

  input {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    border: 0;
    background: ${(props) => props.theme.colors.UploadSurveyInputColor};
    color: ${(props) => props.theme.colors.text.placeholder};
    padding: 0 20px;
    font-size: 1.2rem;

    &::placeholder {
      color: ${(props) => props.theme.colors.text.placeholder};
    }
  }
`;
